module.exports = "https://static.wanderu.com/static/media/not-found-chiku.5a37a54f.svg";